import React, { useState } from 'react';

import ClientsApi from 'api/ClientsApi';
import TextInput from 'components/forms/TextInput/TextInput';

const CustomerSubdomainInput = ({ formik }) => {
  const [isDomainAvailable, setIsDomainAvailable] = useState(null);

  const checkIsDomainAvailable = (domain) => {
    if (!domain) return;

    ClientsApi.checkIsDomainAvalable(domain)
      .then((res) => {
        if (res.data.inUse) {
          setIsDomainAvailable(false);
          formik.setFieldError('subdomain', `Subdomain ${domain}.palm.hr is already in use`);
        } else {
          setIsDomainAvailable(true);
          formik.setFieldError('subdomain', null);
        }
      })
      .catch(() => {});
  };

  const handleChange = (e) => {
    formik.handleChange(e);
    setIsDomainAvailable(null);
    formik.setFieldError('subdomain', null);
  };

  return (
    <div className='d-flex align-items-center gap-4'>
      <TextInput
        name='subdomain'
        label='subdomain'
        value={formik.values.subdomain}
        onChange={handleChange}
        onBlur={formik.handleBlur}
        isRequired
        error={formik.errors.subdomain}
        className='flex-grow-1'
      />
      <button
        className={`btn btn-sm ml-2 ${isDomainAvailable === false ? 'btn-outline-danger' : 'btn-outline-success'}`}
        title='Check is domain available'
        onClick={() => {
          checkIsDomainAvailable(formik.values.subdomain);
        }}
        type='button'
      >
        {isDomainAvailable === null ? 'Test' : isDomainAvailable ? 'OK' : 'Failed'}
      </button>
    </div>
  );
};

export default CustomerSubdomainInput;
